<template>
  <div class="android-container">
    <h1>Android 页面</h1>
    <p>这是 Android 专属页面</p>
    <button @click="redirect">跳转到外部网页</button>
  </div>
</template>

<script>
export default {
  name: 'AndroidPage',
  methods: {
    redirect() {
      // 修改这里的URL为你想跳转的网页
      window.location.href = 'https://www.android.com'
    }
  }
}
</script>

<style scoped>
.android-container {
  padding: 20px;
  text-align: center;
}

h1 {
  color: #3ddc84;
  margin-bottom: 20px;
}

button {
  padding: 10px 20px;
  font-size: 16px;
  background-color: #3ddc84;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
}

button:hover {
  background-color: #2bb968;
}
</style>
